var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    vdpBig: _vm.big,
    vdpDisabled: _vm.disabled,
  },on:{"click":function($event){return _vm.$emit('focus')}}},[_c('date-pick',{attrs:{"value":_vm.value,"format":_vm.format,"nextMonthCaption":_vm.nextMonthCaption,"prevMonthCaption":_vm.prevMonthCaption,"setTimeCaption":_vm.setTimeCaption,"weekdays":_vm.weekdays,"months":_vm.months,"inputAttributes":{ readonly: true },"isDateDisabled":_vm.isDateDisabled},on:{"input":_vm.changeDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }